import { useEffect } from "react";

const SEOHead = ({ 
  title = "KDA Trucking LLC - Dry Van Freight Transportation",
  description = "Professional dry van trucking services in Massachusetts, New Hampshire, Maine, and Rhode Island. Reliable freight transportation across the USA. Get a free quote today!",
}) => {
  
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;
  }, [title, description]);
  
  return null;
};

export default SEOHead;
